module.exports = __webpack_public_path__ + "img/logo-dotpay.f37feff8.svg";